import React from 'react'
import { string, number, shape, oneOfType, array } from 'prop-types'
import { styled } from '@mui/material'

const StyledStoreName = styled('p')(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 700,
  textTransform: 'uppercase',
  fontSize: '16px',
  margin: '0',
  padding: '0',
}))

const StoreName = ({ mark: msStoreData }) => (
  <StyledStoreName className="storeName" role="heading" aria-level="3">
    {msStoreData.name}
  </StyledStoreName>
)

StoreName.propTypes = {
  mark: shape({
    city: string,
    hours: oneOfType([shape({ regularHours: array }), array]),
    lat: number,
    lng: number,
    name: string,
    phoneNumber: string,
    state: string,
    StoreNumber: number,
    title: string,
    zip: string,
  }).isRequired,
}

export default StoreName
